/**
 * Which flows keep their own in-app back stack.
 *
 * Add a row here when a new multi-step flow needs Back to stay inside the flow
 * instead of using the browser/native history. See README.md in this folder.
 *
 * `id`       — stored on each stack entry
 * `rootPath` — landing URL. Opening this path clears that feature's inner screens
 *              so Back from the root cannot return into a nested screen.
 */
export type StackFeature = {
  id: string
  rootPath: string
}

export const STACK_FEATURE = {
  EXPERT_REVIEW: {
    id: 'expert-review',
    rootPath: '/allocation/expert-review'
  },
  STACK_DEMO: {
    id: 'stack-demo',
    rootPath: '/demo/stack'
  }
} as const

export const STACK_FEATURES: readonly StackFeature[] = [
  STACK_FEATURE.EXPERT_REVIEW,
  STACK_FEATURE.STACK_DEMO
]
